import useGroup from "../../projectGroups/hooks/useGroup";

const useUsers = () => {
  const { group, ...rest } = useGroup();
  return { users: group?.members || [], ...rest };
};

export default useUsers;
